import { loadLib } from "../utils/utils";
import { Globals } from "../globals/variables";
export class DelioLabels {
  constructor() {
    this.digitalData = {}; // Objeto que almacenará la configuración de etiquetado
  }

  #setDeclaratives() {
    const data = {
      producto_landing: this.#getProducto(),
      utm_campaign:this.#getUtmCampaign(),
      visit_cvar_4: this.#getProducto(),
      id_affiliated:this.#getIdAffiliated()
    };

    this.#setDigitalData(data);
  }

  async loadDeclaratives() {
    this.#setDeclaratives();
  }

  #setDigitalData(newDFI_client) {
    // Si DFI_client ya existe, se hace un spread para mantener las propiedades existentes
    this.digitalData = { ...this.DFI_client, ...newDFI_client };
  }

  async loadLabels() {
    this.#setDeclaratives();
  }

   getVisitLabels(){
    const data=[

      {
        id:"2" , "value":globalThis.womtp.v_vars[2]
      },
      {
        id:"4" , "value":globalThis.womtp.v_vars[4]
      }
    ]

    return data
  }

  async updateLabelsDelio() {
    try {
      return new Promise((resolve, reject) => {
        const idVisitor = globalThis.Piwik.getAsyncTracker().getVisitorId();
        const data = this.getVisitLabels()
        globalThis.DAL.Ajax({
          type: "jsonp",
          url: Globals.updateVisitLabels,
          data: {
            format: "jsonp",
            idTag: Globals.idTagD1C,
            idVisitor: idVisitor,
            data: JSON.stringify(data),
          },
        }).done(function (value) {
          resolve(true);
        });
      });
    } catch (error) {
      console.error("Error al actualizar etiquetas Delio", error);
    }
  }

  /**
   * Funcion que devuelve el objeto digitalData
   * @returns digitalData
   */

  getDigitalData() {
    return this.digitalData;
  }

  /**
   * Funcion que devuelve el producto
   * @returns producto
   */

  #getProducto() {
    const valorParametro = this.#getParamValueUrl("producto");

    if (!valorParametro) {
      return this.#getParamUrlChoice();
    }

    return valorParametro;
  }

  #getIdAffiliated(){
    const valorParametro = this.#getParamValueUrl("id_affiliated");

    if (!valorParametro) {
      return null;
    }

    return valorParametro;
  }

  #getUtmCampaign(){
    const valorParametro = this.#getParamValueUrl("utm_campaign");

    

    return valorParametro;
  }

  /**
   * Funcion que devuelve el parametro producto recogido de la url
   * @returns producto
   */

  #getParamValueUrl(nombreParametro) {
    const url = globalThis.location.href;
    const urlObj = new URL(url);
    const valor = urlObj.searchParams.get(nombreParametro);
    return valor;
  }

  /**
   * Funcion que devuelve el producto cuando no hay utms en la url . En caso de haber utms comprueba que no haya niguna llamada producto
   * de existir algun parametro llamado producto lo devuelve
   * @returns producto
   */
  #getParamUrlChoice() {
    const url = globalThis.location.href;
    const indiceConversion = url.indexOf("conversion");

    if (indiceConversion === -1) {
      return "marca";
    }

    const subcadena = url.substring(indiceConversion);
    const cadenaProducto = subcadena.split("?")[0];

    const producto = cadenaProducto.split("-")[1]?.trim();

    return producto || "marca";
  }

  async loadDelioLibs(url, idTag) {
    try {
      const result = await loadLib(url, idTag);
      if (result) {
        this.updateLabelsDelio();
        console.log("Scrip cargado correctamente :" + result);
      }
    } catch (error) {
      console.error("Error al cargar el script:", error);
    }
  }
}
